import React, { useEffect, useState } from "react";
import { CustomDialog, CustomTextField } from "../../../../../../../../../common/components";
import { translate } from "../../../../../../../../../common/providers";
import styles from "./SectionNameDialog.module.css";

export default function SectionNameDialog({ open, name, onClose, onRename }) {
	const [tempName, setTempName] = useState("");
	useEffect(() => {
		setTempName(name);
	}, [name]);

	const handleChangeName = (value) => {
		setTempName(value);
	};
	const handleSubmitName = () => {
		onRename(tempName);
		onClose();
		setTempName("");
	};
	const handleCancel = () => {
		onClose();
		setTempName(name);
	};
	return (
		<CustomDialog
			isForm
			open={open}
			submitDisabled={tempName === name || tempName?.length === 0}
			title={translate("dsi.form-studio.view.creation.dialog.rename-section")}
			onClose={handleCancel}
			onSubmit={handleSubmitName}
		>
			<CustomTextField
				autoFocus
				fullWidth
				className={styles.nameInput}
				size="small"
				value={tempName}
				variant="outlined"
				onChange={(e) => handleChangeName(e.target.value)}
			/>
		</CustomDialog>
	);
}
